// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RTYctdWMTubWr_3X1ArK::after{content:"*";color:red;font-weight:500;margin-left:2px}`, "",{"version":3,"sources":["webpack://./lib/inputs/udtspec.module.scss"],"names":[],"mappings":"AACA,6BACC,WAAA,CACA,SAAA,CACA,eAAA,CACA,eAAA","sourcesContent":["@use './lib/scss/index' as *;\n.required-asterisk::after {\n\tcontent: '*';\n\tcolor: red;\n\tfont-weight: 500;\n\tmargin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"required-asterisk": `RTYctdWMTubWr_3X1ArK`
};
export default ___CSS_LOADER_EXPORT___;
